import { Skeleton, Stack } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { Suspense, useEffect, useState } from 'react'
import { lazy } from 'react'
import pMinDelay from 'p-min-delay'
import StoreCheckout from 'GlobalStores/Checkout/StoreCheckout'
import styled from '@emotion/styled'
import MoneyBack from 'Components/Elements/Checkout/MoneyBack'
import { DefaultButton } from 'Components/Elements/Forms'
import { useSizeWindow } from 'Helpers/GlobalHelpers'

import StoreLoader from 'GlobalStores/Cores/Elements/StoreLoader'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import ReCaptchaV3 from 'Components/Elements/ReCaptcha/ReCaptchaV3'

const PreSummaryBoxLazyLoad = lazy(() => pMinDelay(import('../../Elements/Checkout/PreSummaryBox'), 0))
const SouthAfricaCreateAccountWithShippingLazyLoad = lazy(() =>
    pMinDelay(import('../../Elements/Checkout/ShippingAddressForm/Country/SouthAfrica/SouthAfricaCreateAccountWithShipping'), 0)
)
const SouthAfricaShippingAddressLazyLoad = lazy(() => pMinDelay(import('../../Elements/Checkout/ShippingAddressForm/Country/SouthAfrica/SouthAfricaShippingAddress'), 0))

// const SouthAfricaPaymentLazyLoad = lazy(() => pMinDelay(import('../../Elements/Checkout/PaymentReviews/SouthAfricaPaymentReview'), 0))

const PaymentBoxLazyLoad = lazy(() => pMinDelay(import('../../Elements/Checkout/Payment'), 0))

const SouthAfricaCheckoutTheme = observer(({ Sections, step, onPlaceOrder, openLoginModal, setOpenLoginModal }) => {
    const translate = useTranslate()
    const { width } = useSizeWindow()
    const [loading, setLoading] = useState(false)
    const [sectionReady, setSectionReady] = useState(false)

    useEffect(() => {
        setLoading(false)
    }, [])

    const ThemeSections = step => {
        switch (step) {
            case 'payment':
                return <PaymentBoxLazyLoad sectionReady={setSectionReady} onPlaceOrder={onPlaceOrder} />
            case 'create-account':
                return <SouthAfricaCreateAccountWithShippingLazyLoad sectionReady={setSectionReady} />
            default:
                return <SouthAfricaShippingAddressLazyLoad sectionReady={setSectionReady} />
        }
    }

    const extendPlaceOrder = () => {
        return (
            <Stack alignItems={'center'}>
                <DefaultButton
                    titleText={translate('confirm_payment')}
                    disabled={loading}
                    onClick={onPlaceOrder}
                    width={width > 700 ? '340px' : '100%'}
                    isloading={loading.toString()}
                    style={{ marginTop: '50px', fontSize: '18px' }}
                />
                <MoneyBack />
            </Stack>
        )
    }

    useEffect(() => {
        if (StoreLoader.IsFormatApiLoading() === true) {
            setSectionReady(false)
        }
    }, [StoreLoader.IsFormatApiLoading()])

    return (
        <StackStyled stepPaymentOrReview={step === 'payment' ? 'payment' : 'review'}>
            <Suspense fallback={<PageSkeletonFormElement />}>
                <Stack>{ThemeSections(step)}</Stack>
            </Suspense>

            <Stack width={width > 1200 ? '380px' : 'auto'}>
                <Suspense fallback={<PageSkeletonSummaryElement />}>
                    <PreSummaryBoxLazyLoad
                        step={step}
                        edit={false}
                        isReady={StoreCheckout.isReadyToPlaceOrder}
                    />
                </Suspense>
            </Stack>
        </StackStyled>
    )
})

const StackStyled = styled.div`
    padding-top: 40px;
    padding-bottom: 40px;
    min-height: 50vh;
    display: flex;
    flex-direction: ${props => (props.stepPaymentOrReview ? 'column-reverse' : 'column')};
    justify-content: ${props => (props.stepPaymentOrReview ? 'flex-start' : 'flex-end')};
    gap: 20px;

    @media screen and (min-width: 399px) {
        padding-top: 40px;
    }

    @media screen and (min-width: 600px) {
        padding-top: 60px;
    }

    @media screen and (min-width: 768px) {
        padding-top: 40px;
        gap: 20px;
    }

    @media screen and (min-width: 1200px) {
        display: grid;
        grid-template-columns: 770px 370px;
        gap: 22px;
        padding-top: 40px;
    }
`

const PageSkeletonFormElement = observer(props => {
    return (
        <Stack>
            <Stack mb="20px">
                <Skeleton variant="rounded" width={'100%'} height={'340px'} sx={{ margin: '0', borderRadius: '12px' }} />
            </Stack>
            <Stack mb="20px">
                <Skeleton variant="rounded" width={'100%'} height={'400px'} sx={{ margin: '0', borderRadius: '12px' }} />
            </Stack>
            <Stack>
                <Skeleton variant="rounded" width={'100%'} height={'400px'} sx={{ margin: '0', borderRadius: '12px' }} />
            </Stack>
        </Stack>
    )
})

const PageSkeletonSummaryElement = observer(props => {
    return (
        <Stack>
            <Skeleton
                variant="rounded"
                width={'100%'}
                sx={{
                    margin: '0',
                    borderRadius: '12px',
                    height: '370px',
                    // height: '108px',
                    // '@media screen and (min-width: 1200px)': {
                    //     height: '370px'
                    // }
                }}
            />
        </Stack>
    )
})

const PageSkeletonSectionLazyLoad = () => (
    <Stack>
        <Skeleton variant="rounded" width={'100%'} height={'700px'} sx={{ margin: '0', borderRadius: '12px' }} />
    </Stack>
)

export default SouthAfricaCheckoutTheme
